import { ctxReport } from '@/contexts/ReportCtx';
import { styled } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

const StateTextPlaceholderInput = styled('input')(({ theme }) => ({
  '&::placeholder': {
    ...theme.typography.stateText,
  },
}));

export default function AddresseeInput() {
  const { t } = useTranslation();
  const reportCtx = useContext(ctxReport);

  return (
    <StateTextPlaceholderInput
      id="report-addressee-input"
      type="text"
      value={reportCtx?.addressee}
      onChange={(e) => reportCtx?.setAddressee(e.target.value)}
      placeholder={t('report.giveEmail')}
    />
  );
}
